import { Injectable, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { take } from 'rxjs/operators';
import { User } from 'src/app/models/user.model';
import { UserDirectoryService } from 'src/app/services/user-directory.service';
import { EmployeeWorkspaceDialogComponent } from './employee-workspace.dialog';

@Injectable({
  providedIn: 'root',
})
export class EmployeeWorkspaceService {
  private modalCtrl = inject(ModalController);
  private usersService = inject(UserDirectoryService);

  async open(
    userOrGuid: User | string,
    options?: { initialTab?: string; initialShiftDate?: Date | null; initialShiftSiteGuid?: string | null },
  ): Promise<void> {
    const user = typeof userOrGuid === 'string'
      ? await firstValueFrom(this.usersService.get(userOrGuid).pipe(take(1)))
      : userOrGuid;

    if (!user) {
      return;
    }

    const modal = await this.modalCtrl.create({
      component: EmployeeWorkspaceDialogComponent,
      componentProps: {
        user,
        initialTab: options?.initialTab ?? null,
        initialShiftDate: options?.initialShiftDate ?? null,
        initialShiftSiteGuid: options?.initialShiftSiteGuid ?? null,
      },
      cssClass: ['workspace-modal', 'stack-modal'],
    });

    await modal.present();
  }
}
